import React from 'react'

function pill(heldCount, totalWeeks) {
  const ratio = totalWeeks ? heldCount / totalWeeks : 0
  if (ratio >= 0.75) return { bg: '#E5F0D6', fg: '#3F6313' }
  if (ratio >= 0.4) return { bg: '#FCE9CF', fg: '#7A4A0F' }
  return { bg: '#F8D6D3', fg: '#8A2A22' }
}

export function CadenceHeatmap({ rows = [] }) {
  if (!rows.length) {
    return <div style={styles.empty}>No completed sessions in this period.</div>
  }
  return (
    <div>
      <div style={styles.rows}>
        {rows.map((r) => {
          const p = pill(r.heldCount, r.totalWeeks)
          return (
            <div key={r.managerId} style={styles.row}>
              <div style={styles.name} title={r.managerName}>{r.managerName}</div>
              <div style={styles.cells}>
                {r.weeks.map((held, i) => (
                  <div
                    key={i}
                    style={{
                      ...styles.cell,
                      background: held ? '#639922' : '#EAF3DE',
                      border: held ? 'none' : '1px solid #D6E3C0',
                    }}
                    title={`W${i + 1}: ${held ? 'held' : 'no session'}`}
                  />
                ))}
              </div>
              <div style={{ ...styles.pill, background: p.bg, color: p.fg }}>
                {r.heldCount} / {r.totalWeeks}
              </div>
            </div>
          )
        })}
      </div>
      <div style={styles.legend}>
        <span style={styles.legendItem}>
          <span style={{ ...styles.swatch, background: '#639922' }} /> Session held
        </span>
        <span style={styles.legendItem}>
          <span style={{ ...styles.swatch, background: '#EAF3DE', border: '1px solid #D6E3C0' }} /> No session
        </span>
      </div>
    </div>
  )
}

const styles = {
  rows: { display: 'flex', flexDirection: 'column', gap: 6 },
  row: { display: 'flex', alignItems: 'center', gap: 12 },
  name: { minWidth: 140, fontSize: 13, color: 'var(--text-primary)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
  cells: { display: 'flex', gap: 3, flex: 1 },
  cell: { height: 18, flex: 1, borderRadius: 3, minWidth: 10 },
  pill: { fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 10, minWidth: 48, textAlign: 'center' },
  legend: { display: 'flex', gap: 16, marginTop: 12, fontSize: 11, color: 'var(--text-secondary)' },
  legendItem: { display: 'inline-flex', alignItems: 'center', gap: 6 },
  swatch: { display: 'inline-block', width: 10, height: 10, borderRadius: 2 },
  empty: { fontSize: 13, color: 'var(--text-secondary)', padding: 16 },
}
